import { useState, useEffect } from "react"
import Fuse from 'fuse.js'
import api from '../../utils/api'

import Input from "../../shared/components/form/input"
import sanitizeFuseQuery from '../../shared/functions/sanitizeFuseQuery'

// Reaproveita o CSS do modal de NCM — layout de busca genérico (header/lista/item),
// não tem nada específico de NCM no visual.
import './NcmSearchModal.css'

// Tabela de CFOP é pequena (~450 códigos) e estática -- busca 100% local em vez de
// bater no backend a cada tecla. Cache em nível de módulo: uma vez buscada, a lista
// e o índice ficam prontos pro resto da sessão, sem refetch a cada abertura do modal.
let cachedCatalog = null
let cachedIndex = null

const FUSE_OPTIONS = {
    keys: ['description', 'code'],
    threshold: 0.3,
    minMatchCharLength: 3,
    useExtendedSearch: true,
    ignoreLocation: true,
}

function CfopSearchModal({ onSelect }) {
    const [token] = useState(localStorage.getItem('token') || '')
    const [query, setQuery] = useState('')
    const [results, setResults] = useState([])
    const [loading, setLoading] = useState(!cachedCatalog)

    function runSearch(q) {
        const cleanQ = sanitizeFuseQuery(q)
        if (!cleanQ) {
            setResults(cachedCatalog)
            return
        }
        setResults(cachedIndex.search(cleanQ).map((r) => r.item))
    }

    useEffect(() => {
        if (cachedCatalog) {
            setResults(cachedCatalog)
            return
        }
        setLoading(true)
        api.get('/fiscal/cfop/all', {
            headers: { Authorization: `Bearer ${JSON.parse(token)}` },
        }).then((response) => {
            cachedCatalog = response.data.cfopList || []
            cachedIndex = new Fuse(cachedCatalog, FUSE_OPTIONS)
            setResults(cachedCatalog)
            setLoading(false)
        }).catch(() => setLoading(false))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function handleSearchChange(e) {
        const q = e.target.value
        setQuery(q)
        if (cachedCatalog) {
            runSearch(q)
        }
    }

    return (
        <div className="ncm-search">
            <div className="ncm-search-header">
                <p className="ncm-search-title">Buscar CFOP</p>
                <span className="ncm-search-title-accent" />
                <p className="ncm-search-subtitle">Tabela oficial (Ato COTEPE/ICMS 08/2008). Confirme sempre com seu contador antes de emitir de verdade.</p>
            </div>

            <Input type="text" placeholder="Buscar por descrição (venda, devolução, transferência...) ou código" value={query} handleOnChange={handleSearchChange} disabled={loading} />

            <div className="ncm-search-results">
                {loading && <p className="ncm-search-empty">Carregando tabela de CFOP...</p>}
                {!loading && results.length === 0 && (
                    <p className="ncm-search-empty">{query ? `Nenhum CFOP encontrado para "${query}".` : 'Nenhum CFOP cadastrado ainda.'}</p>
                )}
                {results.map((c) => (
                    <div key={c.code} className="ncm-search-item" onClick={() => onSelect(c)}>
                        <span className="ncm-search-item-code">{c.code}</span>
                        <span className="ncm-search-item-desc">{c.description}</span>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default CfopSearchModal
